import React from "react";

export default function FeaturesPage() {

  return (
      <div className="lo-page lo-prose">
        <div className="lo-page-header">
          <h1>Features</h1>
          <p>
            Connect supplies your Nzyme setup with current, curated reference data and keeps an eye on your clusters.
          </p>
        </div>

        <h2>Curated Data</h2>

        <p>
          Your clusters pull the datasets from Connect once an hour and keep a local copy. All lookups run against
          that local cache, so enriching traffic adds no latency and keeps working between updates.
        </p>

        <ul>
          <li><strong>GeoIP:</strong> country and network (ASN) for IPv4 and IPv6 addresses, provided
            by <a href="https://ipinfo.io/products/free-ip-database">IPinfo.io</a></li>
          <li><strong>MAC address vendors:</strong> the manufacturer behind an OUI</li>
          <li><strong>Bluetooth:</strong> company and service identifiers assigned by the Bluetooth SIG</li>
          <li><strong>UAV:</strong> make, model and classification of unmanned aerial vehicles, by Remote ID serial
            number</li>
          <li><strong>Environment:</strong> weather and storm alerts for your locations, currently within the United
            States</li>
        </ul>

        <p>
          Each data type can be switched off per cluster. Alert definitions and fingerprints are planned as further
          data types, so a setup that is connected early picks them up as soon as they ship.
        </p>

        <h2>Cluster Monitoring</h2>

        <p>
          Add as many clusters as you like. Each cluster reports its health indicators, node and tap status and
          throughput every minute, and Connect shows all of them in one place. Notifications when something goes
          wrong are planned for the next release.
        </p>

        <h2>Offline Access</h2>

        <p>
          For air-gapped networks and other setups without internet
          access, <a href="https://go.nzyme.org/contact">contact us</a> about offline access to the same data.
        </p>
      </div>
  )

}
